var _path, _path2, _path3, _path4, _path5, _g, _line, _g2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 226.44 89.3",
    enableBackground: "new 0 0 226.44 89.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5827,
    y1: 71.4596,
    x2: 67.5827,
    y2: 7.7562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#315E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2E5C87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00386C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M79.63,8.91l6.26-1.16l-5.65,57.07c0,0-19.87,0.71-30.97,6.64c0,0,9.53-8.51,24.5-9.12L79.63,8.91z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000208481774680261040000013831202230477828494_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.5116,
    y1: 69.4859,
    x2: 75.5116,
    y2: 14.358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#315E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2E5C87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00386C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000000208481774680261040000013831202230477828494_)",
    d: "M87.46,14.36l4.63,0.41L87,67.04 c-0.09,0.91-0.88,1.58-1.79,1.53c-4.88-0.28-19.48-0.93-26.27,0.92c0,0,7.62-2.38,23.41-2.59L87.46,14.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157998231564688544820000009603404579206421897_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.0429,
    y1: 72.0055,
    x2: 46.0429,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#315E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2E5C87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00386C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000157998231564688544820000009603404579206421897_)",
    d: "M46.04,19.26c0,0-12.35-13.75-31.95-19.26 l6.12,60.05c0,0,13.28,0.66,25.83,11.95c12.56-11.3,25.82-11.95,25.82-11.95L78,0C58.39,5.51,46.04,19.26,46.04,19.26z  M68.26,45.33c-0.78,0.17-1.5-0.06-2-0.55h-9.34l-0.82-1.9l-4.29,17.18l-6.33-26.91l-6.67,17.08l-2.79-9.87l-2.72,4.15h-7.25 c-0.5,0.69-1.42,1.07-2.38,0.78c-0.7-0.21-1.26-0.81-1.42-1.52c-0.33-1.41,0.72-2.67,2.08-2.67c0.68,0,1.3,0.32,1.68,0.82h6 l4.83-7.55l2.38,7.97l7.04-17.71l5.75,24.99l3.88-15.6l2.72,7.9h7.44c0.39-0.5,1-0.82,1.68-0.82c1.38,0,2.46,1.31,2.06,2.76 C69.61,44.58,68.99,45.16,68.26,45.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133500593769638414730000015268828084315041946_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.5013,
    y1: 71.4596,
    x2: 24.5013,
    y2: 7.7562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#315E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2E5C87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00386C"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000133500593769638414730000015268828084315041946_)",
    d: "M12.45,8.91L6.19,7.76l5.65,57.07 c0,0,19.87,0.71,30.97,6.64c0,0-9.53-8.51-24.5-9.12L12.45,8.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045602184015676965220000003530123790674993039_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.5724,
    y1: 69.4859,
    x2: 16.5724,
    y2: 14.358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#315E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2E5C87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00386C"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000045602184015676965220000003530123790674993039_)",
    d: "M4.63,14.36L0,14.77l5.24,53.9 c0,0,19.67-1.43,27.9,0.82c0,0-7.62-2.38-23.41-2.59L4.63,14.36z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M116.03,78.21c1.81,0,3.39,0.83,4.35,2.18l-0.64,0.51c-0.85-1.19-2.15-1.91-3.7-1.91 c-2.59-0.05-4.68,2.12-4.63,4.74c-0.05,2.66,2.04,4.79,4.63,4.76c1.55,0,2.85-0.7,3.7-1.89l0.64,0.51 c-0.96,1.35-2.54,2.19-4.35,2.19c-3.02,0.07-5.58-2.49-5.51-5.54C110.46,80.69,113.02,78.16,116.03,78.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M124.32,85.38c0.1,1.84,1.47,3.15,3.24,3.15c1.04,0,1.92-0.41,2.63-1.24l0.52,0.54 c-0.78,0.91-1.91,1.47-3.16,1.47c-2.23,0.05-4.13-1.86-4.08-4.09c-0.05-2.23,1.81-4.16,3.98-4.11c1.94,0,3.52,1.4,3.52,3.51 c0,0.34-0.02,0.6-0.07,0.78H124.32z M130.13,84.65c0.07-1.71-1.19-2.8-2.71-2.8c-0.8,0-1.47,0.26-2.04,0.8 c-0.57,0.52-0.91,1.19-1.03,2.01H130.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M138.77,81.98h-0.41c-1.35,0-2.67,0.95-2.67,2.53v4.63h-0.82v-7.88h0.78v1.34 c0.57-0.91,1.52-1.39,2.61-1.39c0.21,0,0.42,0.05,0.51,0.05V81.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M145.99,89.13c-0.41,0.11-0.82,0.16-1.22,0.16c-1.48,0-2.41-0.73-2.41-2.36v-4.92h-1.37v-0.75h1.37v-2.23 h0.83v2.23h2.54v0.75h-2.54v4.89c0,1.19,0.65,1.65,1.71,1.65c0.31,0,0.68-0.05,1.09-0.13V89.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M149.83,77.51c0.39,0,0.72,0.33,0.72,0.72s-0.33,0.72-0.72,0.72c-0.41,0-0.72-0.33-0.72-0.72 S149.42,77.51,149.83,77.51z M149.42,81.26h0.82v7.88h-0.82V81.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M155.68,81.26h2.07v0.75h-2.07v7.13h-0.82v-7.13h-1.14v-0.75h1.14v-2.15c0-1.63,0.93-2.36,2.38-2.36 c0.31,0,0.62,0.03,0.9,0.1v0.72c-0.24-0.05-0.51-0.07-0.75-0.07c-1.06,0-1.71,0.46-1.71,1.65V81.26z M160.02,77.51 c0.39,0,0.72,0.33,0.72,0.72s-0.33,0.72-0.72,0.72c-0.41,0-0.72-0.33-0.72-0.72S159.61,77.51,160.02,77.51z M159.61,81.26h0.82 v7.88h-0.82V81.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M168.39,81.1c1.32,0,2.45,0.62,3.18,1.61l-0.59,0.47c-0.67-0.88-1.53-1.32-2.59-1.32 c-1.83,0-3.23,1.48-3.23,3.33c0,1.88,1.4,3.34,3.21,3.34c1.06,0,1.92-0.44,2.61-1.32l0.59,0.47c-0.73,0.99-1.88,1.61-3.2,1.61 c-2.22,0.05-4.11-1.88-4.06-4.11C164.27,82.95,166.16,81.05,168.39,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M180.97,89.13h-0.78V87.9c-0.57,0.9-1.58,1.4-2.82,1.4c-0.77,0-1.4-0.18-1.92-0.55 c-0.52-0.38-0.78-0.91-0.78-1.58c0-1.29,1.09-2.1,2.74-2.1h2.74v-0.9c0-1.5-0.85-2.3-2.17-2.3c-0.99,0-1.73,0.46-2.4,1.32 l-0.57-0.46c0.77-1.09,1.76-1.63,3.02-1.63c1.78,0,2.95,1.09,2.95,3.1V89.13z M180.14,85.76h-2.66c-1.29,0-1.97,0.49-1.97,1.35 c0,0.96,0.88,1.47,1.94,1.47c1.45,0,2.69-1.03,2.69-2.38V85.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M189.29,89.13c-0.41,0.11-0.82,0.16-1.22,0.16c-1.48,0-2.41-0.73-2.41-2.36v-4.92h-1.37v-0.75h1.37v-2.23 h0.83v2.23h2.54v0.75h-2.54v4.89c0,1.19,0.65,1.65,1.71,1.65c0.31,0,0.68-0.05,1.09-0.13V89.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M193.13,77.51c0.39,0,0.72,0.33,0.72,0.72s-0.33,0.72-0.72,0.72c-0.41,0-0.72-0.33-0.72-0.72 S192.72,77.51,193.13,77.51z M192.72,81.26h0.82v7.88h-0.82V81.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M201.51,81.1c2.25,0,4.08,1.83,4.08,4.09c0.05,2.23-1.86,4.16-4.09,4.11c-2.22,0.05-4.11-1.88-4.06-4.11 C197.38,82.92,199.27,81.05,201.51,81.1z M201.51,81.86c-1.83,0-3.23,1.45-3.23,3.34c0,1.86,1.4,3.33,3.21,3.33 s3.24-1.47,3.24-3.33C204.74,83.31,203.3,81.86,201.51,81.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M215.65,89.13h-0.82v-4.92c0-1.39-0.85-2.35-2.2-2.35c-0.68,0-1.26,0.23-1.7,0.67s-0.65,1.01-0.65,1.68 v4.92h-0.82v-7.88h0.78v1.06c0.54-0.78,1.42-1.22,2.51-1.22c1.81,0,2.89,1.24,2.89,3.07V89.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M219.84,87.13c0.72,0.91,1.47,1.4,2.46,1.4c0.99,0,1.76-0.49,1.76-1.39c-0.08-0.86-0.51-1.08-1.61-1.58 l-0.72-0.31c-1.24-0.54-1.94-1.08-1.94-2.1c0-0.64,0.24-1.12,0.73-1.5c0.49-0.38,1.08-0.55,1.78-0.55c1.09,0,1.96,0.49,2.54,1.26 l-0.54,0.52c-0.6-0.67-1.29-1.01-2.05-1.01c-0.91,0-1.6,0.44-1.6,1.24c0,0.67,0.42,0.96,1.48,1.42l0.73,0.33 c1.32,0.59,2.04,1.17,2.04,2.27c0,0.7-0.26,1.24-0.77,1.61c-0.51,0.37-1.13,0.57-1.86,0.57c-1.3,0-2.35-0.65-3.02-1.63 L219.84,87.13z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006677992199577206040000000309080460133496973_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.5166,
    y1: 67.5961,
    x2: 225.5057,
    y2: 67.5961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#315E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2E5C87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00386C"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "url(#SVGID_00000006677992199577206040000000309080460133496973_)",
    strokeWidth: 1.938,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 85.49,
    y1: 67.6,
    x2: 224.54,
    y2: 67.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M106.7,22.35h11.85c6.59,0,11.37,4.11,11.37,10.17c0,6.02-4.78,10.22-11.37,10.22h-5.4v11.13h-6.45V22.35z  M118.54,37.11c3.01,0,4.78-1.86,4.78-4.59c0-2.67-1.86-4.49-4.78-4.49h-5.4v9.07H118.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M135.83,30.23h6.45v13.76c0,2.72,1.86,4.54,4.49,4.54c2.48,0,4.39-1.81,4.39-4.54V30.23h6.45v13.23 c0,6.59-4.68,10.99-10.84,10.99c-6.3,0-10.94-4.39-10.94-10.99V30.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M165.2,18.05h6.45v35.82h-6.45V18.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M180.58,45.94c2.05,2.15,4.3,3.2,6.64,3.2c1.72,0,3.01-0.67,3.01-1.96c0-1-0.67-1.39-2.44-2.15l-2.53-1.05 c-4.35-1.77-6.45-3.73-6.45-7.21c0-4.44,3.53-7.07,8.69-7.07c3.53,0,6.35,1.19,8.5,3.53l-3.25,3.96c-1.58-1.48-3.34-2.24-5.3-2.24 c-1.58,0-2.53,0.57-2.53,1.67c0,0.91,0.62,1.34,2.48,2.1l2.29,0.96c4.59,1.86,6.64,3.73,6.64,7.21c0,2.34-0.86,4.2-2.63,5.54 c-1.72,1.34-3.92,2.01-6.59,2.01c-4.16,0-7.64-1.72-9.79-4.59L180.58,45.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M207.8,44.23c0.76,3.01,3.2,4.68,6.64,4.68c2.34,0,4.54-0.81,6.59-2.39l2.67,4.39 c-2.82,2.34-5.97,3.53-9.46,3.53c-7.31,0.14-13.09-5.54-12.94-12.37c-0.14-6.83,5.54-12.51,12.37-12.37 c6.54,0,11.13,4.82,11.13,10.99c0,1.15-0.14,2.34-0.43,3.53H207.8z M218.55,39.69c-0.05-2.91-2.29-4.78-5.11-4.78 c-2.72,0-4.92,1.86-5.64,4.78H218.55z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#00386C",
    cx: 224.54,
    cy: 67.6,
    r: 1.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseLogo);
export default __webpack_public_path__ + "static/media/Pulse-Logo.2abee17cd99a8626a6a13b041c49f34d.svg";
export { ForwardRef as ReactComponent };